//Name: Gender
//CODE: Gender
//Age: ''
//Gender: Both
const genderOptions = [
  { id: '0', value: "male", label: "Male" },
  { id: '1', value: "female", label: "Female" },
  { id: '2', value: "all", label: "Non-binary / Other" },
  { id: '3', value: "", label: "Undisclosed" }
];  

export default genderOptions;


// WEBPACK FOOTER //
// ./src/data/gender.js